// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__fCWAR","title":"BackImages_title__3Uvhk","images":"BackImages_images__3bqlg"};